import { useSelector } from 'react-redux'
import { AppBar as MuiAppBar, Box, Divider, Toolbar as MuiToolbar, Typography } from '@mui/material'

import { selectOrganisation } from '@/app/slices/organisationSlice'

import LanguageSelectorButton from '../LanguageSelectorButton/LanguageSelectorButton'

import AppLogo from './AppLogo'

const classes = {
    appBar: {
        backgroundColor: 'white',
        color: 'white',
        displayPrint: 'none',
    },
    appLogo: {
        height: 32,
        px: 1,
        py: 1,
        cursor: 'pointer',
        boxSizing: 'content-box',
    },
    appBarTitle: {
        fontWeight: 500,
        fontSize: '18px',
        lineHeight: '21px',
        textTransform: 'uppercase',
        color: 'text.primary',
    },
    menuDivider: {
        backgroundColor: 'divider',
        margin: '10px 16px',
    },
}

/**
 * Simplified public app bar component for error pages.
 *
 * This component is used instead of AppToolbar on error pages that render
 * outside the SplitFactoryProvider context (e.g., AppInsightsErrorBoundary
 * in index.jsx). It provides basic organization branding without requiring
 * Split.io feature flags.
 *
 * @returns {React.ReactElement} A simplified app bar with organization branding
 */
const PublicAppBar = () => {
    const storeSettings = useSelector(selectOrganisation)

    return (
        <MuiAppBar
            color="default"
            position="sticky"
            sx={classes.appBar}
        >
            <MuiToolbar sx={{ paddingBlock: 1 }}>
                <AppLogo
                    logoUrl={storeSettings?.webStoreLogoUri}
                    sx={classes.appBarLogo}
                />

                <Divider
                    orientation="vertical"
                    sx={classes.menuDivider}
                    flexItem
                />

                <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                    <Typography sx={classes.appBarTitle}>
                        {storeSettings?.webStoreDisplayName || storeSettings?.organisationName || 'Web Store'}
                    </Typography>
                </Box>

                <LanguageSelectorButton />
            </MuiToolbar>
        </MuiAppBar>
    )
}

export default PublicAppBar
